import { render, staticRenderFns } from "./AllowedGroups.vue?vue&type=template&id=18a44e49&scoped=true"
import script from "./AllowedGroups.vue?vue&type=script&lang=js"
export * from "./AllowedGroups.vue?vue&type=script&lang=js"
import style0 from "./AllowedGroups.vue?vue&type=style&index=0&id=18a44e49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a44e49",
  null
  
)

export default component.exports